import React, { FC, useCallback, useEffect, useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  Heading,
  HStack,
  Icon,
  SimpleGrid,
  Spinner,
  Tab,
  Table,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Th,
  Thead, 
  Tr,
  useToast,
  VStack,
  Text,
  useBreakpointValue,
  Select as ChakraSelect
} from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import { format, parseISO, setYear } from 'date-fns'
import { SubmitHandler, useForm } from 'react-hook-form'
import * as Yup from 'yup'
import { Input } from '../../Components/Form/Input'
import { InputMaskCustom } from '../../Components/Form/InputMask'
import { Select } from '../../Components/Form/Select'
import { Header } from '../../Components/Header'
import { Sidebar } from '../../Components/Sidebar'
import api from '../../Services/api'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { id } from 'date-fns/locale'
import { PLANS_CLUB, USERS_TYPE } from '../../Services/contants'
import { TiDeleteOutline } from 'react-icons/ti'
import { MoneyInput } from '../../Components/Form/MoneyInput'
import { TextArea } from '../../Components/Form/TextArea'
import { TablePlaceholder } from '../../Components/TablePlaceholder'
import { IBalanceDTO } from '../../interfaces/IBalanceDTO'
import { IBalanceMovimentationsDTO } from '../../interfaces/IBalanceMovimentationsDTO'
import { BalanceMovimentationModal } from '../../Components/Modals/BalanceMovimentationModal'
import { Loader } from '../../Components/Loader'
import { IQuotasProperty } from '../../interfaces/IQuotasProps'
import { BalanceCard } from '../../Components/BalanceCard'
import { generateYearOptions } from '../../utils/generateYearOptions'
import year from 'react-datepicker/dist/year'

interface IBalanceProps {
  property: string;
  total: number;
  used: number;
  available: number;
  reserved: number;
}

interface User {
  name: string
  email: string
  phone: string
  document: string
  type: string
  cpf?: string
  plan: {
    plan: string
  }
}

interface OptionsProps {
  label: string
  value: string
}

const createUserFormSchema = Yup.object().shape({
  name: Yup.string().required('Nome é obrigatório'),
  email: Yup.string()
    .email('Preencha um e-mail válido')
    .required('E-mail é obrigatório'),
  phone: Yup.string().required('Telefone é obrigatório'),
  document: Yup.string().required('CPF/CNPJ é obrigatório')
})

const typeOptions = [
  {
    label: 'MyDoor Homes',
    value: 'HOMES'
  },
  {
    label: 'MyDoor Club',
    value: 'CLUB'
  },
  {
    label: 'MyDoor Homes e Club',
    value: 'HOMESCLUB'
  },
  {
    label: 'Nenhum tipo atribuído',
    value: 'NONE'
  }
]

const planOptions = [
  {
    label: 'ESSENCIAL',
    value: 'ESSENCIAL'
  },
  {
    label: 'EXCLUSIVE',
    value: 'EXCLUSIVE'
  }
]

const UsersCreate: FC = () => {
  const [loading, setLoading] = useState(false)
  const [showPlan, setShowPlan] = useState(false)
  const [balanceClub, setBalanceClub] = useState<IBalanceDTO[]>([])
  const [balanceHomes, setBalanceHomes] = useState<IBalanceDTO[]>([])
  const [balanceMovimentations, setBalanceMovimentations] = useState<IBalanceMovimentationsDTO[]>([])
  const [movimentationType, setMovimentationType] = useState<'ADD' | 'REMOVE' | undefined>(undefined)
  const [user, setUser] = useState<User | undefined>(undefined)
  const [noQuota, setNoQuota] = useState(false);
  const [properties, setProperties] = useState<string[]>([]);
  const [balances, setBalances] = useState<IBalanceProps[]>([]);
  const [year, setYear] = useState(() => {
    const today = new Date()
    return String(today.getFullYear())
  })

  const yearOptions = generateYearOptions()
  
  const params = useParams()
  const toast = useToast()
  const navigate = useNavigate()

  const isWideScreen = useBreakpointValue({
    base: false,
    lg: true
  })

  const { register, handleSubmit, formState, setValue, watch } = useForm({
    resolver: yupResolver(createUserFormSchema)
  })
  const { errors } = formState

  
  const handleSubmitForm: any = useCallback(
    async (values: any) => {
      const {
        name, email, phone, document, type, plan
      } = values

      const normalizePhone = String(`${phone}`.replace(/([^0-9]+)/g, ''))

      if (normalizePhone.length < 11) {
        toast({
          title: 'Telefone inválido',
          position: 'top',
          isClosable: true,
          status: 'error',
          variant: 'solid'
        })
        return
      }

      const payload = {
        name,
        email,
        password: '123123',
        cpf: document,
        phone,
        type,
        plan_club: plan

      }

      try {
        params?.id
          ? await api.put(`/users/${params?.id}`, payload)
          : await api.post('/users', payload)

        toast({
          title: `${params?.id ? 'Editado' : 'Cadastrado'} com sucesso`,
          position: 'top',
          isClosable: true,
          status: 'success',
          variant: 'solid'
        })

        navigate('/users')
        // router.push("/users");
      } catch (error) {
        toast({
          title: error.response.data.message,
          position: 'top',
          isClosable: true,
          status: 'error',
          variant: 'solid'
        })
      }
    },
    [toast, params, navigate]
  )

  const loadItem = useCallback(async (id: string) => {

    try {
      setLoading(true)
      const resp = await api.get(`/users/${String(params?.id)}`)
      const data: User = resp.data.user

      console.log('data: ', data)

      setValue('name', data.name)
      setValue('email', data.email)
      setValue('document', data.cpf)
      setValue('phone', data.phone)
      setValue('type', data.type)

      if (data.type === USERS_TYPE.CLUB || data.type === USERS_TYPE.HOMESCLUB) {
        setValue('plan', data.plan.plan)
        setShowPlan(true)
      }

      setUser(data)
    } catch (error) {
      console.log('error edit: ', error)
      toast({
        title: error.response.data.message,
        position: 'top',
        isClosable: true,
        status: 'error',
        variant: 'solid'
      })
    } finally {
      setLoading(false)
    }
  }, [toast, setValue, params])

  const loadBalanceUser = useCallback(async (id: string) => {
    try {
      const { data } = await api.get(`/balance/user/${String(params?.id)}`, { params: { origin: ['CLUB', 'HOMES'] } })
    
      setBalanceClub(data.filter((item: IBalanceDTO) => item.origin === 'CLUB'))
      setBalanceHomes(data.filter((item: IBalanceDTO) => item.origin === 'HOMES'))
      
      // Extract all movimentations into a single array
      const allMovimentations = data.reduce((acc: IBalanceMovimentationsDTO[], balance: IBalanceDTO) => {
        if (balance.movimentations?.data) {
          return [...acc, ...balance.movimentations.data]
        }
        return acc
      }, [])

      // Sort by created_at in descending order
      setBalanceMovimentations(allMovimentations.sort((a: IBalanceMovimentationsDTO, b: IBalanceMovimentationsDTO) => 
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      ))
    } catch (error) {
      console.log('error edit: ', error)
      toast({
        title: error.response.data.message,
        position: 'top',
        isClosable: true,
        status: 'error',
        variant: 'solid'
      })
    }
  }, [toast, setValue, params])

  useEffect(() => {
    if (params?.id) {
      loadItem(params?.id)
      loadBalanceUser(params?.id)
    }
  }, [params])

  const handleSelectTypeUser = useCallback((e: string) => {


    if (e === USERS_TYPE.CLUB || e === USERS_TYPE.HOMESCLUB) {
      setShowPlan(true)
    }
  }, [])

  const loadBalance = useCallback(async (houses: string[], year: string) => {
    try {
      const {data: dados} = await api.get('/balance', {
        params: {
          year,
          properties: houses,
          user_id: String(params?.id),
        },
      });

      console.log('dados loadBalance: ', dados);

      setBalances([...dados]);
    } catch (error) {
      console.log('error: ', error);
      console.log('erro ao buscar os dados: ', error?.response?.data?.message);
      setBalances([]);
    }
  }, [params?.id]);

  const loadQuotas = useCallback(async () => {
    try {
      
      const {data} = await api.get('/quotas', {
        params: {
          user_id: String(params?.id),
          pag: 1,
          all: true,
        },
      });


      const propertiesFiltered: IQuotasProperty[] = [];
      const quotaIdsAdicionados = new Set();

      data?.data?.forEach((item: IQuotasProperty) => {
        if (!quotaIdsAdicionados.has(item.property_id)) {
          propertiesFiltered.push(item);
          quotaIdsAdicionados.add(item.property_id);
        }
      });

      const normalize = propertiesFiltered?.map((item: IQuotasProperty) => {
        return item.property?.id;
      }).filter((id): id is string => id !== undefined);

      if (!normalize?.length) {
        setNoQuota(true);
        return;
      }

      setProperties(normalize);
    } catch (error) {
      console.log('loadQuotas error: ', error);
    } 
  }, [user]);

  useEffect(() => {

      loadQuotas();

  }, [user]);

  useEffect(() => {
    if (!properties?.length) {
      return;
    }

    loadBalance(properties, year);
  }, [year, properties, loadBalance]);

  

  return (
    <Box>
      <Header />
       {movimentationType && <BalanceMovimentationModal userType={user?.type} type={movimentationType} user_id={String(params?.id)} onClose={() => {
        loadBalanceUser(String(params?.id))
        setMovimentationType(undefined)
       }} /> }

       {loading ? <Loader /> : (
        <Flex w="100%" my="6" maxWidth={1480} mx="auto" px={['4', '4', '6']}>
          <Sidebar />

          <Box flex="1" borderRadius={8} bg="white" p="8">
        <Tabs variant="soft-rounded" mt="15px">
        <TabList>
          <Tab>Dados Cadastrais</Tab>
          { user?.type && [USERS_TYPE.CLUB, USERS_TYPE.HOMESCLUB].includes(user.type) && (
            <Tab>Wallet Club</Tab>
          )}
          { user?.type && [USERS_TYPE.HOMES, USERS_TYPE.HOMESCLUB].includes(user.type) && (
            <Tab>Wallet Homes</Tab>
          )}
          <Tab>Movimentações</Tab>
          {/* <Button
            variant="ghost"
            ml="auto"
            as="button"
            size="sm"
            fontSize="md"
            width="200px"
            color="green.primary"
            leftIcon={
              <Icon as={TiDeleteOutline} fontSize="25" color="green.primary" />
            }
            onClick={() => handleDeleteOption(data)}
          >
            Excluir Opção
          </Button> */}
        </TabList>


        <TabPanels>
          <TabPanel mt="20px">
          
            <Box
              as="form"
              onSubmit={handleSubmit(handleSubmitForm)}
              // onSubmit={() => {}}
              flex="1"
              
            >
              {/* <Heading size="lg" fontWeight="normal" color="blue.500">
                {params?.id ? 'Editar Usuário' : 'Criar Usuário'}
              </Heading>
              <Divider my="6" borderColor="blue.700" /> */}

              <Heading size="md" fontWeight="normal" color="blue.500" mb="6">
                Dados Cadastrais
              </Heading>

              <VStack spacing={['6', '8']}>
                <SimpleGrid spacing={['6', '9']} w="100%" minChildWidth="240px">
                  <Input
                    label="Nome"
                    placeholder="Preencha o nome"
                    // errors={errors.name}
                    {...register('name')}
                  />
                  <Input
                    label="E-mail"
                    placeholder="Preencha o e-mail do usuário"
                    // errors={errors.email}
                    {...register('email')}
                  />
                </SimpleGrid>

                <SimpleGrid spacing={['6', '9']} w="100%" minChildWidth="240px">
                  <InputMaskCustom
                    type="text"
                    label="CPF"
                    // errors={errors.cpf}
                    {...register('document')}
                    placeholder="Digite o cpf"
                    mask="999.999.999-99"
                  />

                  <InputMaskCustom
                    type="text"
                    label="Telefone"
                    // errors={errors.phone}
                    {...register('phone')}
                    placeholder="Digite o telefone"
                    mask="(99)99999-9999"
                  />
                </SimpleGrid>

                <SimpleGrid spacing={['6', '9']} w="100%" minChildWidth="240px">
                    <Select
                      label="Tipo de Usuário"
                      placeholder="Selecionar Tipo"
                      errors={errors.type}
                      extraFunction={handleSelectTypeUser}
                      {...register('type')}
                      options={typeOptions}

                    />

                    {showPlan && (
                      <Select
                        label="Plano do Club"
                        placeholder="Selecionar plano"
                        errors={errors.plan}
                        {...register('plan')}
                        options={planOptions}
                      />
                    )}
                </SimpleGrid>

              </VStack>

              <Flex mt={['6', '8']} justify="flex-end">
                <HStack>
                  <Button
                    as="a"
                    bg="green.teal"
                    _hover={{ bgColor: 'gray.500' }}
                    color="green.dark"
                  >
                    Cancelar
                  </Button>

                  <Button
                    type="submit"
                    bg="green.dark"
                    _hover={{ bgColor: 'gray.500' }}
                    color="green.light"
                    isLoading={formState.isSubmitting}
                  >
                    Salvar
                  </Button>
                </HStack>
              </Flex>

            </Box>
              
        
          </TabPanel>
          {user?.type && [USERS_TYPE.CLUB, USERS_TYPE.HOMESCLUB].includes(user.type) && (
          <TabPanel>
            <Box
                as="form"
                onSubmit={() => {}}
                // onSubmit={() => {}}
                flex="1"
                
              >
                <Heading size="md" fontWeight="normal" color="blue.500" mb="6">
                  Saldo Club
                </Heading>

                <Table colorScheme="blue">
                    <Thead>
                      <Tr>
                        <Th>Créditos</Th>
                        <Th>Ano</Th>
                        
                        <Th w="8"></Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {!!balanceClub?.length ? balanceClub.map((i) => (
                        <Tr key={i.id}>
                        
                          <Td>
                            <Text fontWeight="bold">{i.total} M¥Cs</Text>
                          </Td>
                          <Td>
                            <Text fontWeight="bold">{i.year}</Text>
                          </Td>
                          
                          {/* <Td>
                            <Flex>

                              {isWideScreen
                                ? (

                                <Button

                                  as="a"
                                  href={`/users/create/${i.id}`}
                                  size="sm"
                                  fontSize="sm"
                                  mr="2"
                                  bg="green.dark"

                                  color='green.light'
                                  leftIcon={
                                    <Icon as={RiPencilLine} fontSize="16" />
                                  }
                                >
                                  Visualizar
                                </Button>
                                  )
                                : (
                                <IconButton
                                  mr="3"
                                  colorScheme="green"
                                  aria-label="Edit Content"
                                  icon={<Icon as={RiPencilLine} size="30" />}
                                />
                                  )}

                              {isWideScreen
                                ? (
                                <Button
                                  as="button"
                                  onClick={() => setSelectedItem(i)}
                                  size="sm"
                                  fontSize="sm"

                                  bg="green.teal"
                                  leftIcon={
                                    <Icon as={AiOutlineDelete} fontSize="16" />
                                  }
                                >
                                  Excluir
                                </Button>
                                  )
                                : (
                                <IconButton
                                  colorScheme="red"
                                  aria-label="Edit Content"
                                  icon={<Icon as={AiOutlineDelete} size="30" />}
                                  onClick={() => setSelectedItem(i)}
                                />
                                  )}
                            </Flex>
                          </Td> */}
                        </Tr>
                      )) : (
                        <Tr>
                          <Td colSpan={3} textAlign="center">
                            <Text>Nenhum saldo encontrado.</Text>
                            <Button onClick={() => setMovimentationType('ADD')} bg="green.dark" _hover={{ bgColor: 'gray.500' }} color="green.light" marginTop='20px'>Adicionar Créditos</Button>
                          </Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
              
            </Box>
          </TabPanel>
          )}
          {user?.type && [USERS_TYPE.HOMES, USERS_TYPE.HOMESCLUB].includes(user.type) && (
          <TabPanel>
            <Box
                as="form"
                onSubmit={() => {}}
                // onSubmit={() => {}}
                flex="1"
                
              >
                <Heading size="md" fontWeight="normal" color="blue.500" mb="6">
                  Wallet Homes
                </Heading>

                <Table colorScheme="blue">
                    <Thead>
                      <Tr>
                        <Th>Créditos</Th>
                        <Th>Casa</Th>
                        <Th>Ano</Th>
                        
                        <Th w="8"></Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {balanceHomes.map((i) => (
                        <Tr key={i.id}>
                        
                          <Td>
                            <Text fontWeight="bold">{i.total} Créditos</Text>
                          </Td>
                          <Td>
                            <Text fontWeight="bold">{i.property?.name}</Text>
                          </Td>
                          <Td>
                            <Text fontWeight="bold">{i.year}</Text>
                          </Td>
                          
                          {/* <Td>
                            <Flex>

                              {isWideScreen
                                ? (

                                <Button

                                  as="a"
                                  href={`/users/create/${i.id}`}
                                  size="sm"
                                  fontSize="sm"
                                  mr="2"
                                  bg="green.dark"

                                  color='green.light'
                                  leftIcon={
                                    <Icon as={RiPencilLine} fontSize="16" />
                                  }
                                >
                                  Visualizar
                                </Button>
                                  )
                                : (
                                <IconButton
                                  mr="3"
                                  colorScheme="green"
                                  aria-label="Edit Content"
                                  icon={<Icon as={RiPencilLine} size="30" />}
                                />
                                  )}

                              {isWideScreen
                                ? (
                                <Button
                                  as="button"
                                  onClick={() => setSelectedItem(i)}
                                  size="sm"
                                  fontSize="sm"

                                  bg="green.teal"
                                  leftIcon={
                                    <Icon as={AiOutlineDelete} fontSize="16" />
                                  }
                                >
                                  Excluir
                                </Button>
                                  )
                                : (
                                <IconButton
                                  colorScheme="red"
                                  aria-label="Edit Content"
                                  icon={<Icon as={AiOutlineDelete} size="30" />}
                                  onClick={() => setSelectedItem(i)}
                                />
                                  )}
                            </Flex>
                          </Td> */}
                        </Tr>
                      ))}
                    </Tbody>
                </Table>

               
                <Flex alignItems="center" justifyContent="space-between" mb="6" mt="6">
                  <Heading size="md" fontWeight="normal" color="blue.500"  >
                    Saldo Homes
                  </Heading>
                   

                    <ChakraSelect w={100} placeholder='Ano' onChange={e => setYear(e.target.value)} defaultValue={year} value={year}>
                      {yearOptions?.map(i => <option key={i.value} value={i.value}>{i.value}</option>)}
                    </ChakraSelect>
                  </Flex>

                {!noQuota && !balances?.length ? (
                  <Flex>
                    <Text>
                      {`Saldo não encontrado em ${year}`}
                    </Text>
                  </Flex>
                ) : (
                  balances?.map(i => (
                    <Box key={i.property}>
                      <Text fontSize="18px" marginBottom="20px">{i.property}</Text>
      
                      
                        <BalanceCard title="Total" amount={i.total} />
                        <BalanceCard title="Reservado" amount={i.reserved || 0} />
                        <BalanceCard title="Utilizado" amount={i.used || 0} />
                        <BalanceCard title="Disponível" amount={i.available || 0} />
                    
                    </Box>
                  ))
                )}
              
            </Box>
          </TabPanel>
          )}
          <TabPanel>
          {!user?.type  ? (
                  <Text>
                    Nenhum tipo de usuário atribuído. Vá no menu Dados Cadastrais e atribua um tipo ao usuário.
                  </Text>
            ) : (
            <Box
            as="form"
            onSubmit={() => {}}
            // onSubmit={() => {}}
            flex="1"
            
          >

            <Flex alignItems="center" justifyContent="space-between" mb="6">
              <Heading size="md" fontWeight="normal" color="blue.500" >
                Movimentações de Créditos
              </Heading>

                <HStack>
                  <Button
                    
                    bg="green.dark"
                    _hover={{ bgColor: 'gray.500' }}
                    color="green.light"
                    onClick={() => setMovimentationType('ADD')}
                  >
                    Adicionar Créditos
                  </Button>

                  <Button
                    onClick={() => setMovimentationType('REMOVE')}

                    bg="red"
                    _hover={{ bgColor: 'gray.500' }}
                    color="white"
                    isLoading={formState.isSubmitting}
                  >
                    Remover Créditos
                  </Button>
                </HStack>
              
            </Flex>
            

            <Table colorScheme="blue">
                <Thead>
                  <Tr>
                    <Th>Movimentação</Th>
                    <Th>Origem</Th>
                    
                    <Th w="8"></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {balanceMovimentations.map((i) => (
                    <Tr key={i.id}>
                    
                      <Td>
                        <Text fontWeight="bold">{i.message}</Text>
                      </Td>
                      <Td>
                        <Text fontWeight="bold">{i.origin === 'CLUB' ? 'Club' : 'Homes'}</Text>
                      </Td>
                      
                      {/* <Td>
                        <Flex>

                          {isWideScreen
                            ? (

                            <Button

                              as="a"
                              href={`/users/create/${i.id}`}
                              size="sm"
                              fontSize="sm"
                              mr="2"
                              bg="green.dark"

                              color='green.light'
                              leftIcon={
                                <Icon as={RiPencilLine} fontSize="16" />
                              }
                            >
                              Visualizar
                            </Button>
                              )
                            : (
                            <IconButton
                              mr="3"
                              colorScheme="green"
                              aria-label="Edit Content"
                              icon={<Icon as={RiPencilLine} size="30" />}
                            />
                              )}

                          {isWideScreen
                            ? (
                            <Button
                              as="button"
                              onClick={() => setSelectedItem(i)}
                              size="sm"
                              fontSize="sm"

                              bg="green.teal"
                              leftIcon={
                                <Icon as={AiOutlineDelete} fontSize="16" />
                              }
                            >
                              Excluir
                            </Button>
                              )
                            : (
                            <IconButton
                              colorScheme="red"
                              aria-label="Edit Content"
                              icon={<Icon as={AiOutlineDelete} size="30" />}
                              onClick={() => setSelectedItem(i)}
                            />
                              )}
                        </Flex>
                      </Td> */}
                    </Tr>
                  ))}
                </Tbody>
              </Table>
          
          </Box>

          )}
          </TabPanel>
        </TabPanels>
      </Tabs>
      </Box>
        </Flex>
      )}
  </Box>

  
  )
}

export { UsersCreate }
